import t from "react-input-mask";
import o, { css as l } from "styled-components";
import e from "../../utils/colors.js";
import { device as i } from "../../utils/device.js";
const c = o.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  max-width: 350px;
  width: 100%;

  @media ${i.isMobile} {
    max-width: none;
  }
`, p = o.label`
  align-self: stretch;
  height: 24px;
  font-weight: 600;
  overflow-wrap: break-word;
  color: ${e.blueGrey};
`, m = o.small`
  color: ${e.red};
  display: block;
  font-size: 1rem;
  position: relative;
`, h = o(t)`
  align-self: stretch;
  text-align: left;
  width: ${(r) => {
  switch (r.mode) {
    case "FullDate":
      return "115px";
    case "MonthYear":
      return "80px";
    case "MonthYearShort":
      return "60px";
    default:
      return "";
  }
}};
  height: 46px;
  border-radius: 2px;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5rem;
  letter-spacing: -0.32px;
  outline: 0px !important;
  color: ${e.blueGrey75};
  border: solid 1px ${(r) => r.isError ? e.red : e.blueGrey};
  background-color: ${(r) => r.disabled ? e.darkGrey10 : e.white};
  padding: 0 16px;
  margin: 8px 0;

  ${(r) => r.disabled ? " cursor: not-allowed;" : l`&:active, &:focus {
    border: solid 1px ${r.isError ? e.red : e.orange};
    color: ${e.blueGrey};
    background-color: transparent;
  }`};

  :placeholder {
    color: ${e.blueGrey75};
  }
`;
export {
  c as Container,
  p as Label,
  m as Small,
  h as StyledInputMask
};
